import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-user-custom-cell',
  templateUrl: './user-custom-cell.component.html'
})

export class UserCustomCellComponent implements OnInit {
  data: any;
  params: any;
  deleteOnly : boolean = false
  constructor(private http: HttpClient, private router: Router) {}

  agInit(params) {
    console.log(params)
    this.params = params;
    this.data = params.value;
    if(this.data){
      if(this.data == "delete_only"){
        this.deleteOnly = true
      }
    }
  }

  ngOnInit() {}

   edit() {
      this.params.context.componentParent.editUser(this.params.data);
   }

   delete(): void {
    this.params.context.componentParent.deleteUser(this.params.data);
  }
}

export type CellAction = (params) => void;
